"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createTransaction = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var transaction_1 = require("./transaction");
/**
 * EVM Transaction factory.
 * By default the transaction is an EIP-1559 transaction.
 * @see prepareTransaction that will make sure it's compatible or not
 */
var createTransaction = function (account) {
    var _a, _b;
    return ({
        family: "evm",
        mode: "send",
        amount: new bignumber_js_1["default"](0),
        useAllAmount: false,
        recipient: "",
        maxFeePerGas: new bignumber_js_1["default"](0),
        maxPriorityFeePerGas: new bignumber_js_1["default"](0),
        gasLimit: transaction_1.DEFAULT_GAS_LIMIT,
        nonce: account.operationsCount + 1,
        chainId: ((_b = (_a = account.currency) === null || _a === void 0 ? void 0 : _a.ethereumLikeInfo) === null || _b === void 0 ? void 0 : _b.chainId) || 0,
        feesStrategy: "medium",
        type: 2
    });
};
exports.createTransaction = createTransaction;
//# sourceMappingURL=createTransaction.js.map